import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

export async function listSalonUsers(token) {
  const res = await axios.get(`${API}/salons/me/users`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function addSalonUser({ email, role }, token) {
  const res = await axios.post(
    `${API}/salons/me/users`,
    { email, role },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateSalonUser(userId, payload, token) {
  const res = await axios.patch(`${API}/salons/me/users/${userId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function removeSalonUser(userId, token) {
  await axios.delete(`${API}/salons/me/users/${userId}`, {
    headers: authHeaders(token),
  });
}

export async function createStaffUser(payload, token) {
  const res = await axios.post(`${API}/salons/me/staff-users`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
